import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Ár rogha',
  bestPriceBadge: 'Praghas is fearr',
  regulatedNotice: {
    prescriptionOnly: 'Ar oideas amháin',
    professionalUse: 'Úsáid ghairmiúil',
    fromVeterinarian: 'Ar fáil ó do thréidlia',
    fromPharmacist: 'Ar fáil ó chógaiseoir',
    noOnlinePurchase: 'Níl sé ar díol ar líne',
    professionalSupply: 'Díoltar trí sholáthraithe gairmiúla é',
    whyNoLink: 'Déanaimid measúnú ar an táirge seo ach ní chuirimid nasc chuige ar fáil.',
  },
};
